import _implicitStylesheets from "./securityStep1Welcome.css";
import _implicitScopedStylesheets from "./securityStep1Welcome.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _i18nLink from "i18n/link";
import _appxSecurityReviewProgressIndicator from "appx/securityReviewProgressIndicator";
import _appxSecurityReviewSubmission from "appx/securityReviewSubmission";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="section-title slds-size_2-of-3${0}"${2}>${"t1"}</div>`;
const $fragment2 = parseFragment`<div class="gp2-notification-title slds-m-bottom_xx-small${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<div class="gp2-notification-subtitle slds-m-bottom_medium${0}"${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<div class="horizontal-divider${0}"${2}></div>`;
const $fragment5 = parseFragment`<div class="section-sub-title slds-size_2-of-3${0}"${2}>${"t1"}</div>`;
const $fragment6 = parseFragment`<div class="section-description slds-size_2-of-3${0}"${2}>${"t1"}</div>`;
const $fragment7 = parseFragment`<div class="doc-item-text${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "step": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "gp2-notification": true,
    "slds-grid": true,
    "slds-size_4-of-5": true,
    "slds-m-bottom_x-large": true
  },
  key: 3
};
const stc2 = {
  classMap: {
    "icon": true,
    "icon-warning": true
  },
  key: 4
};
const stc3 = {
  key: 6
};
const stc4 = {
  classMap: {
    "gp2-notification-subtitle": true
  },
  key: 11
};
const stc5 = {
  "gp2-notification-icon": true
};
const stc6 = {
  classMap: {
    "slds-form-element": true,
    "progress-indicator": true
  },
  key: 14
};
const stc7 = {
  classMap: {
    "slds-form-element": true
  },
  key: 22
};
const stc8 = {
  classMap: {
    "docs": true,
    "slds-grid": true,
    "slds-size_3-of-4": true
  },
  key: 23
};
const stc9 = {
  "slds-size_1-of-2": true,
  "slds-m-bottom_large": true,
  "slds-p-right_medium": true
};
const stc10 = {
  classMap: {
    "doc-item": true
  },
  key: 25
};
const stc11 = {
  classMap: {
    "slds-grid": true,
    "slds-m-bottom_x-small": true,
    "slds-grid_vertical-align-center": true
  },
  key: 26
};
const stc12 = {
  "doc-item-title": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, b: api_bind, k: api_key, i: api_iterator} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.labels.welcomeTitle))]), $cmp.show2GPWarning ? api_element("div", stc1, [api_element("span", stc2, [api_custom_element("c360-icon", _c360Icon, {
    props: {
      "iconName": "utility:warning",
      "iconDescription": $cmp.sharedLabels.warning,
      "size": "small"
    },
    key: 5
  })]), api_element("div", stc3, [api_static_fragment($fragment2, 8, [api_static_part(1, null, api_dynamic_text($cmp.labels.gp2WarningTitle))]), api_static_fragment($fragment3, 10, [api_static_part(1, null, api_dynamic_text($cmp.labels.gp2WarningSubtitle1))]), api_element("div", stc4, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.labels.gp2WarningSubtitle2,
      "target": "_blank"
    },
    key: 12
  })])]), api_custom_element("c360-icon", _c360Icon, {
    classMap: stc5,
    props: {
      "iconName": "utility:close",
      "iconClass": "normal",
      "iconDescription": $cmp.sharedLabels.close
    },
    key: 13,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.dismiss2GPWarning))
    }
  })]) : null, api_element("div", stc6, [api_custom_element("appx-security-review-progress-indicator", _appxSecurityReviewProgressIndicator, {
    props: {
      "steps": $cmp.steps
    },
    key: 15
  })]), api_static_fragment($fragment4, 17), $cmp.showDiggingIntoDetials ? api_static_fragment($fragment5, 19, [api_static_part(1, null, api_dynamic_text($cmp.labels.resourcesTitle))]) : null, $cmp.showDiggingIntoDetials ? api_static_fragment($fragment6, 21, [api_static_part(1, null, api_dynamic_text($cmp.labels.resourcesDetail))]) : null, $cmp.showDiggingIntoDetials ? api_element("div", stc7, [api_element("div", stc8, api_iterator($cmp.docs, function (item) {
    return api_element("div", {
      classMap: stc9,
      key: api_key(24, item.title)
    }, [api_element("div", stc10, [api_element("div", stc11, [api_custom_element("c360-icon", _c360Icon, {
      props: {
        "iconName": "utility:knowledge_base",
        "iconDescription": $cmp.labels.documentIcon,
        "size": "x-small",
        "iconClass": "normal"
      },
      key: 27
    }), api_custom_element("i18n-link", _i18nLink, {
      classMap: stc12,
      props: {
        "message": item.title,
        "target": "_blank"
      },
      key: 28
    })]), api_static_fragment($fragment7, 30, [api_static_part(1, null, api_dynamic_text(item.text))])])]);
  }))]) : null, $cmp.isSubmitted ? api_custom_element("appx-security-review-submission", _appxSecurityReviewSubmission, {
    props: {
      "submissionCount": $cmp.submitCount,
      "srStatus": $cmp.partnerReviewStatus,
      "opsStatus": $cmp.opsReviewStatus,
      "solutionTechnology": $cmp.solutionTechnology,
      "srDate": $cmp.securityReviewDate,
      "feedbackItem": $cmp.lastFeedbackItem,
      "challengeRaised": $cmp.challengeRaised,
      "challenge": $cmp.lastChallengeRaised,
      "partnerWaitingReason": $cmp.partnerWaitingReason,
      "hasFalsePositiveDocument": $cmp.hasFalsePositiveDocument,
      "solution": $cmp.solution
    },
    key: 31
  }) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4f3ue2mllr4";
tmpl.legacyStylesheetToken = "appx-securityStep1Welcome_securityStep1Welcome";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
